module.exports = __webpack_public_path__ + "static/media/home-road-pickup-xlarge.7892aefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-pickup-xlarge.png
// module id = 1527
// module chunks = 27